import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import CheckboxGroupField from '../../../../shared/components/CheckboxGroupField'
import { Label } from '../../../../shared/compass-ui'
import ControlledNumericInput from '../../../shared/ControlledNumericInput'
import ControlledSelect from '../../../shared/ControlledSelect'
import TextInputError from '../../../shared/TextInputError'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'

const JOB_ROLE_OPTIONS = [
  { label: 'Accounting / Finance / Bookkeeping', value: 'accounting' },
  { label: 'Administrative / Office Support', value: 'administrative' },
  { label: 'Business Owner / Self-Employed', value: 'business_owner' },
  { label: 'Consultant / Advisor', value: 'consultant' },
  { label: 'Creative / Design / Media', value: 'creative' },
  { label: 'Customer Service / Call Center', value: 'customer_service' },
  { label: 'Driver / Delivery / Transportation', value: 'driver' },
  { label: 'Education / Teaching / Training', value: 'education' },
  { label: 'Engineering / Architecture', value: 'engineering' },
  { label: 'Food Service / Hospitality Worker', value: 'food_service' },
  { label: 'Healthcare Practitioner', value: 'healthcare' },
  { label: 'Human Resources / Recruiting', value: 'human_resources' },
  { label: 'IT / Software / Technical', value: 'it_software' },
  { label: 'Laborer / General Worker', value: 'laborer' },
  { label: 'Legal', value: 'legal' },
  { label: 'Machine Operator / Production Worker', value: 'machine_operator' },
  { label: 'Management / Operations', value: 'management' },
  { label: 'Marketing / Communications', value: 'marketing' },
  { label: 'Military / Armed Forces', value: 'military' },
  { label: 'Personal Care / Service Provider', value: 'personal_care' },
  { label: 'Protective Services', value: 'protective_services' },
  { label: 'Retail / Sales Associate', value: 'retail' },
  { label: 'Sales / Business Development', value: 'sales' },
  { label: 'Scientist / Researcher', value: 'scientist' },
  { label: 'Skilled Trades', value: 'skilled_trades' },
  { label: 'Other', value: 'other' },
]

const PAYMENT_METHOD_OPTIONS = [
  { label: 'Hourly wages', value: 'hourly' },
  { label: 'Salary', value: 'salary' },
  { label: 'Freelance or gig income', value: 'freelance' },
  { label: 'Other', value: 'other' },
]

const EmploymentDetails: FC = () => {
  const {
    register,
    formState: {
      errors: {
        jobRole: jobRoleError,
        paymentMethod: paymentMethodError,
        timeAtCurrentJob: timeAtCurrentJobError,
      },
    },
    clearErrors,
  } = useFormContext()

  return (
    <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-6">
      <HiddenFieldMirror name="jobRole" />
      <HiddenFieldMirror name="paymentMethod" />
      <div>
        <ControlledSelect
          id="job-role-select"
          name="jobRole"
          label={EXTRA_QUESTION_LABELS.jobRole}
          options={JOB_ROLE_OPTIONS}
          error={typeof jobRoleError?.message === 'string'}
          errorId="jobRole-error"
          registerOptions={{
            onChange: () => {
              if (jobRoleError) clearErrors('jobRole')
            },
          }}
        />
        {typeof jobRoleError?.message === 'string' && (
          <TextInputError id="jobRole-error">This field is required</TextInputError>
        )}
      </div>
      <div>
        <Label htmlFor="time-at-current-job-input">{EXTRA_QUESTION_LABELS.timeAtCurrentJob}</Label>
        <ControlledNumericInput
          name="timeAtCurrentJob"
          id="time-at-current-job-input"
          suffix="years"
        />
        {typeof timeAtCurrentJobError?.message === 'string' && (
          <TextInputError>{timeAtCurrentJobError.message}</TextInputError>
        )}
      </div>
      <div>
        <CheckboxGroupField
          name="paymentMethod"
          label={EXTRA_QUESTION_LABELS.paymentMethod}
          options={PAYMENT_METHOD_OPTIONS}
          hasError={typeof paymentMethodError?.message === 'string'}
          errorId="paymentMethod-error"
          inputProps={register('paymentMethod')}
        />
        {typeof paymentMethodError?.message === 'string' && (
          <TextInputError id="paymentMethod-error">This field is required</TextInputError>
        )}
      </div>
    </div>
  )
}

export default EmploymentDetails
